import { useEffect, useState } from "react";
import { fetchSupplyTypes, downloadSupplyTypesExcel } from "../Api/ViewSupplyTypeMaster";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewSupplyTypeMaster = () => {
  const [supplyTypes, setSupplyTypes] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadSupplyTypes = async () => {
      try {
        const data = await fetchSupplyTypes();
        setSupplyTypes(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Supply Types`);
      }
    };

    loadSupplyTypes();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadSupplyTypesExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'SupplyTypes_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Supply Types data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h2 className="list-title">View Supply Types</h2>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || supplyTypes.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {supplyTypes.length > 0 ? (
              <Table bordered hover responsive className="data-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Supply Type ID</th>
                    <th>Supply Type Code</th>
                    <th>Supply Type Description</th>
                    <th>Created On Date</th>
                    <th>Created On Time</th>
                    <th>Created By</th>
                    <th>Changed On Date</th>
                    <th>Changed On Time</th>
                    <th>Changed By</th>
                  </tr>
                </thead>
                <tbody>
                  {supplyTypes.map((supplyType, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{supplyType.supplyTypeId}</td>
                      <td>{supplyType.supplyTypeCode}</td>
                      <td>{supplyType.supplyTypeDescription}</td>
                      <td>{moment(supplyType.createdOnDate).format('L')}</td>
                      <td>{supplyType.createdOnTime}</td>
                      <td>{supplyType.createdBy}</td>
                      <td>{supplyType.changedOnDate ? moment(supplyType.changedOnDate).format('L') : 'N/A'}</td>
                      <td>{supplyType.changedOnTime || 'N/A'}</td>
                      <td>{supplyType.changedBy || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="no-data">No supply types found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewSupplyTypeMaster;